import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { ROUTE_POINT_FIELDS } from './fieldGroup.config';
import { cloneDeep } from 'lodash-es';
import { RevealFieldsComponent } from './reveal-fields.component';

@Component({
  selector: 'formly-route-point',
  template: `
    <div class="route-point">
      @if (field.props?.label && !field.props?.hideLabel) {
        <h3 class="route-point__title">{{ field.props.label }}</h3>
      }

      <div class="route-point__content">
        <!-- props.revealFields: those children sit behind a "Toevoegen" menu until picked or filled. -->
        @if (field.props?.['revealFields']?.length) {
          <dd-reveal-fields [fields]="bodyFields()" [revealKeys]="field.props['revealFields']" />
        } @else {
          @for (fieldItem of bodyFields(); track fieldItem?.id ?? fieldItem?.key ?? $index) {
            <formly-field [field]="fieldItem"></formly-field>
          }
        }
      </div>

      @if (field.props?.description) {
        <p class="route-point__description">{{ field.props.description }}</p>
      }
    </div>
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
    }

    .route-point {
      display: block;
      width: 100%;
      padding: 0.75rem 0;
    }

    .route-point__title {
      margin: 0 0 0.5rem;
      font-size: 0.95rem;
      font-weight: 600;
    }

    .route-point__content {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .route-point__description {
      margin: 0.5rem 0 0;
      font-size: 0.85rem;
      color: var(--fuse-text-secondary, #6b7280);
    }
  `,
  imports: [FormlyModule, RevealFieldsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyRoutePointComponent extends FieldType implements OnInit {
  /**
   * The children this component draws. In a route with `stopStyle: 'card'` the child marked
   * `props.stopSlot: 'footer'` is drawn by the route's card footer instead, so it is left out here.
   */
  protected readonly bodyFields = signal<FormlyFieldConfig[]>([]);

  ngOnInit(): void {
    if (!this.field.fieldGroup || this.field.fieldGroup.length === 0) {
      this.field.fieldGroup = cloneDeep(ROUTE_POINT_FIELDS);
    }
    const inCard = this.field.parent?.props?.['stopStyle'] === 'card';
    this.bodyFields.set(
      inCard ? this.field.fieldGroup.filter(f => f.props?.['stopSlot'] !== 'footer') : this.field.fieldGroup
    );
  }
}
